import { Typography, Layout, Divider, Row, Col, Card, Grid } from "antd";
import TickerTable from "../components/TickerTable";
import CaptureRatios from "../components/CaptureRatios";
import React from "react";
import NivoPieChart from "../../../charts/nivo/NivoPieChart";
import NivoDonut from "../../../modules/Charts/Nivo/NivoDonut";
import StyleboxHeatmap from "../../../components/Charts/StyleboxHeatmap";
import Explainer from "../../../components/Explainer";
const { useBreakpoint } = Grid;
const TickersView = ({ portfolio, enhancedTickers, padding = '' }) => {

    const bp = useBreakpoint();
    const pieData = enhancedTickers && [...enhancedTickers]
        .filter(x => x.weight > 0)
        .map(item => ({ id: item.symbol.toUpperCase(), value: item.weight?.toFixed?.(1) }))
        .sort((a, b) => b.value - a.value);

    const StyleboxCard = ()=>(
        <Card bordered={false}
              title={(
                  <Explainer title={'Equity Styles'}
                             tooltip={'Morningstar Equity Stylebox Categories'}
                  />
              )}>
            <div className={'px-2 py-1'}>
                <Typography.Title level={5} style={{ fontWeight: '500' }}>Stylebox Categories</Typography.Title>
            </div>
            <Divider />
            <div style={{ height: 300, width: '100%', margin: 'auto' }}>
                <StyleboxHeatmap style={portfolio?.composite?.style} size={portfolio?.composite?.size} />
            </div>
        </Card>
    )

    const CaptureCard = ()=>(
        <CaptureRatios upside={portfolio?.stats?.captures?.upside ?? 0} downside={portfolio?.stats?.captures?.downside ?? 0} />
    )

    const PieCard = ()=>(
        <Card bordered={false}
              title={(
                  <Explainer title={'Largest Portfolio Holdings'}
                             tooltip={'Top securities (stocks, etfs, and funds) held by this model portfolio'}
                  />
              )}
        >
            <Divider />
            <div style={{ height: 300, width: '100%', margin: 'auto' }}>
                <NivoPieChart data={pieData.length > 7 ? pieData.slice(0, 7) : pieData} radius={0.01} showLabels={true} legend={false}
                    legendPosition={'right'} legendDirection={'column'} legendWidth={0}
                />
            </div>
        </Card>
    )
    return (
        <Layout className={'px-6'}>
            <Row gutter={[16, 16]}>
                {!bp.xl && (
                    <Row justify={'end'}>
                        <CaptureCard bordered={false} />
                    </Row>
                )}
                <Col xs={24} xl={16} className={'py-4'}>
                    <div className={'p-3'}>
                        <TickerTable tickers={enhancedTickers} />
                    </div>
                </Col>
                {bp.xl && (
                    <Col span={8} className={"border-l border-gray-100 py-6"}>
                        <div className={'h-screen overflow-y-auto hide-scrollbar'} style={{ background: "#FFF"}}>
                            <CaptureCard />

                            <Divider className={'border border-b border-red-300'} />
                            {pieData && (
                                <PieCard />
                            )}
                            <Divider />
                            {portfolio?.composite?.style && portfolio?.composite?.size && (
                                <StyleboxCard />
                            )}
                        </div>
                </Col>
                )}
            </Row>
        </Layout>
    )
}

export default TickersView;